/** Flatten values for client-side table search */
export function adminSearchText(...parts: unknown[]): string {
  return parts
    .flatMap((part) => {
      if(part == null) return [];
      if(typeof part === "object") return [JSON.stringify(part)];
      return [String(part)];
    })
    .join(" ")
    .toLowerCase();
}

export function adminMatchesSearch(query: string, haystack: string): boolean {
  const q = query.trim().toLowerCase();
  if(!q) return true;
  return haystack.toLowerCase().includes(q);
}
